const PERIOD_TYPE_KEY = {
  mensal: "mensal",
  monthly: "mensal",
  trimestral: "trimestral",
  quarterly: "trimestral",
  semestral: "semestral",
  semiannual: "semestral",
  anual: "anual",
  annual: "anual",
};

// Ondas = coletas mensais contidas no período (semestre = 6 meses, não 2).
const PERIOD_ONDAS = {
  mensal: 1,
  trimestral: 3,
  semestral: 6,
  anual: 12,
};

const MONTH_NAMES = {
  Jan: "Janeiro",
  Fev: "Fevereiro",
  Mar: "Março",
  Abr: "Abril",
  Mai: "Maio",
  Jun: "Junho",
  Jul: "Julho",
  Ago: "Agosto",
  Set: "Setembro",
  Out: "Outubro",
  Nov: "Novembro",
  Dez: "Dezembro",
};

function getPeriodTypeKey(type) {
  return PERIOD_TYPE_KEY[type] || null;
}

export function formatPeriodLabel(type, name) {
  if (!name) return "";
  const key = getPeriodTypeKey(type);
  if (!key) return name;

  if (key === "mensal") {
    const [month, year] = name.split("/");
    const monthName = MONTH_NAMES[month] || month;
    const fullYear = year ? `20${year}` : "";
    return `${monthName} ${fullYear}`.trim();
  }

  if (key === "trimestral" || key === "semestral") {
    return name.replace("/", " ");
  }

  return name;
}

export function buildPerDefaultLabels(periods = []) {
  return periods.reduce(
    (acc, period) => {
      const key = getPeriodTypeKey(period.type);
      if (!key) return acc;
      return { ...acc, [key]: period.name };
    },
    {
      mensal: "",
      trimestral: "",
      semestral: "",
      anual: "",
    }
  );
}

export function buildPerFromPeriods(periods = []) {
  return periods.reduce(
    (acc, period) => {
      const key = getPeriodTypeKey(period.type);
      if (!key) return acc;
      return {
        ...acc,
        [key]: {
          label: formatPeriodLabel(period.type, period.name),
          short: period.name,
          ondas: PERIOD_ONDAS[key],
          resp: period.respondents || 0,
        },
      };
    },
    {
      mensal: null,
      trimestral: null,
      semestral: null,
      anual: null,
    }
  );
}

const isGeral = (p) =>
  (!p.city || p.city === "") &&
  (!p.nps_segment || p.nps_segment === "") &&
  (!p.client_type || p.client_type === "");

const toTime = (value) => (value ? new Date(value).getTime() : Number.NaN);

/**
 * Rótulo e contagens do período selecionado, a partir dos períodos reais da
 * API (state.dashboard.periods). Substitui a constante PER de _shared.jsx,
 * que tinha rótulos fixos ("Março 2026", "T1 2026") e aparecia na tela como
 * se fosse o período escolhido.
 *
 * ondas = meses (períodos mensais gerais) com coleta dentro do intervalo do
 * período; para mensal é 1. Sem end_date, cai no tamanho nominal do tipo.
 *
 * @returns {{label: string, short: string, ondas: number|null, resp: number|null}}
 */
export function buildSelectedPer(periods = [], periodName, respondents = null) {
  const resp = Number.isFinite(respondents) ? respondents : null;
  const geral = periods.filter(isGeral);
  const period = geral.find((p) => p.name === periodName);
  if (!period) {
    return { label: periodName || "", short: periodName || "", ondas: null, resp };
  }
  const key = getPeriodTypeKey(period.type);
  let ondas = PERIOD_ONDAS[key] ?? null;
  const inicio = toTime(period.start_date);
  const fim = toTime(period.end_date);
  if (key && key !== "mensal" && Number.isFinite(inicio) && Number.isFinite(fim)) {
    ondas = geral.filter((p) => {
      if (getPeriodTypeKey(p.type) !== "mensal") return false;
      const t = toTime(p.start_date);
      return t >= inicio && t <= fim;
    }).length;
  }
  return {
    label: formatPeriodLabel(period.type, period.name),
    short: period.name,
    ondas,
    resp,
  };
}
